import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/codebuild/output/src828441159/src/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/components/primitives/button.tsx");
